import AttributeCardBoolStatus from './AttributeCardBoolStatusHOC';
import AttributeCardEnumStatus from './AttributeCardEnumStatusHOC';

export const AttributeCardEnumStatusHOC = AttributeCardEnumStatus;
export const AttributeCardBoolStatusHOC = AttributeCardBoolStatus;
